const colorFactory = (enumObj) => {
    const obj = Object.assign({}, enumObj);
    return Object.assign(Object.assign({}, obj), { get: (key) => obj[key] });
};
const issueColors = colorFactory({
    1: 'yellow',
    2: 'blue',
    4: 'green',
    8: 'grey',
    16: 'red',
});
const recommendationColors = colorFactory({
    1: 'yellow',
    2: 'grey',
    4: 'blue',
    8: 'red',
    16: 'orange',
    32: 'blueTwo',
    64: 'grellow',
    128: 'green',
});
const companyColors = colorFactory({
    1: 'grey',
    2: 'yellow',
    4: 'red',
    8: 'green',
    3: 'orange',
});
export { issueColors, recommendationColors, companyColors };
